import React from 'react'
import { Link } from 'react-router-dom'

const Header = () => {
  return (
    <>
     <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
      <div className="container-fluid">
        <Link className="navbar-brand  logo-container" to="/">
          <img src="/logo/1000.jpg" alt="College Logo" className="logo-img" />
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <Link className="nav-link mx-lg-2 active" to="/">
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link mx-lg-2  active" to="/about">
              About 
              </Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link mx-lg-2  active" to="/department">
                Department
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link mx-lg-2   active" to="/admission">
                Admission
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link mx-lg-2   active" to="/events">
                Events
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link mx-lg-2    active" to="/contact">
                Contact Us
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link mx-lg-2  active" to="/login">
              Login
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    </>
  )
}

export default Header
